var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 136,
    viewBox: "0 0 244 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 244,
    height: 136
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.097 0H0V135.226H243.097V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_59)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: -3,
    width: 179,
    height: 139
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.452 -2.90323H32.6452V135.226H210.452V-2.90323Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_59)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 1,
    width: 169,
    height: 134
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.978 1.67743H37.1191V134.645H205.978V1.67743Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0043 129.694H199.093",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6239 99.1149C56.805 99.1149 57.8803 98.419 58.3485 97.3348C59.9534 93.6179 63.6495 91.0159 67.9558 91.0159H117.953C122.259 91.0159 125.955 93.6179 127.56 97.3348C128.028 98.4192 129.103 99.1149 130.284 99.1149C131.501 99.1149 132.57 100.006 132.701 101.215C132.856 102.639 131.744 103.843 130.351 103.843H130.285C129.104 103.843 128.028 104.539 127.56 105.624C125.955 109.34 122.259 111.942 117.953 111.942H67.9556C63.6496 111.942 59.9532 109.34 58.3483 105.624C57.8801 104.539 56.805 103.843 55.6237 103.843H55.557C54.2134 103.843 53.1315 102.723 53.1955 101.365C53.2554 100.093 54.351 99.1149 55.6239 99.1149Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6239 78.188C56.805 78.188 57.8803 77.492 58.3485 76.4078C59.9534 72.6909 63.6495 70.0889 67.9558 70.0889H117.953C122.259 70.0889 125.955 72.6909 127.56 76.4078C128.028 77.4922 129.103 78.188 130.284 78.188C131.501 78.188 132.57 79.0788 132.701 80.2879C132.856 81.7121 131.744 82.9164 130.351 82.9164H130.285C129.104 82.9164 128.028 83.6124 127.56 84.6966C125.955 88.4135 122.259 91.0155 117.953 91.0155H67.9556C63.6496 91.0155 59.9532 88.4135 58.3483 84.6966C57.8801 83.6122 56.805 82.9164 55.6237 82.9164H55.557C54.2134 82.9164 53.1315 81.7955 53.1955 80.4378C53.2554 79.1662 54.351 78.188 55.6239 78.188Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.35 61.9902H130.285C129.103 61.9902 128.028 62.686 127.559 63.77C125.954 67.4869 122.259 70.0893 117.952 70.0893H67.9552C63.6501 70.0893 59.9541 67.4871 58.3495 63.77C57.8805 62.686 56.8042 61.9902 55.6241 61.9902H55.5568C54.2134 61.9902 53.1313 60.8678 53.1947 59.511C53.2562 58.2387 54.3517 57.2604 55.6241 57.2604C56.8042 57.2604 57.8805 56.5646 58.3495 55.4806C59.9543 51.7637 63.6501 49.1613 67.9552 49.1613H117.952C122.259 49.1613 125.955 51.7637 127.56 55.4806C128.028 56.5646 129.103 57.2604 130.285 57.2604C130.892 57.2604 131.465 57.4833 131.899 57.8581C132.336 58.231 132.635 58.7557 132.701 59.3611C132.854 60.7851 131.743 61.9902 130.35 61.9902Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.952 111.942H67.955C63.6497 111.942 59.9538 109.34 58.3489 105.625C57.8799 104.539 56.8055 103.843 55.6235 103.843H55.5562C54.2128 103.843 53.1326 102.722 53.196 101.365C53.2556 100.093 54.3512 99.1148 55.6235 99.1148C56.8055 99.1148 57.8799 98.419 58.3489 97.335C59.9538 93.6179 63.6497 91.0155 67.955 91.0155H93.3867",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1824 70.0889H67.955C63.6497 70.0889 59.9538 72.6913 58.3489 76.4084C57.8799 77.4924 56.8055 78.1881 55.6235 78.1881C54.3512 78.1881 53.2556 79.1664 53.196 80.4388C53.1326 81.7957 54.2128 82.9162 55.5562 82.9162H55.6235C56.8055 82.9162 57.8799 83.612 58.3489 84.696C59.9538 88.4131 63.6497 91.0155 67.955 91.0155H93.3867",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4147 49.7773C65.5198 49.3794 66.7115 49.1623 67.955 49.1623H90.967",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.306 53.7443C58.9332 54.2882 58.6122 54.8706 58.3489 55.4818C57.8799 56.5658 56.8055 57.2615 55.6235 57.2615C54.3512 57.2615 53.2556 58.2398 53.196 59.5103C53.1326 60.8691 54.2128 61.9896 55.5562 61.9896H55.6235C56.8055 61.9896 57.8799 62.6854 58.3489 63.7694C59.9538 67.4865 63.6497 70.0889 67.955 70.0889H94.1824",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.166 122.298H52.7418C51.3841 122.298 50.2835 121.197 50.2835 119.84V116.165C50.2835 114.808 51.3841 113.707 52.7418 113.707H133.166C134.524 113.707 135.624 114.808 135.624 116.165V119.84C135.624 121.197 134.524 122.298 133.166 122.298Z",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3279 122.298H57.9689V129.469H71.3279V122.298Z",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.683 122.298H115.324V129.469H128.683V122.298Z",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.913 9.95759L159.236 7.87687C161.072 6.72793 163.408 6.75445 165.217 7.94473L168.089 9.83483C168.742 10.2649 169.479 10.5516 170.252 10.6759L174.235 11.3173C176.463 11.6761 178.251 13.3521 178.752 15.553L179.304 17.9762C179.527 18.9597 180.016 19.8633 180.716 20.5893L183.181 23.146C184.719 24.7403 185.158 27.0975 184.297 29.1383L183.004 32.2056C182.668 33.0024 182.524 33.8669 182.582 34.7297L182.787 37.7558C182.929 39.8451 181.879 41.8354 180.075 42.8985L177.115 44.6425C176.51 44.9991 175.978 45.4677 175.548 46.0231L173.197 49.0602C171.97 50.645 169.982 51.4429 168 51.146L163.306 50.443C162.608 50.3384 161.896 50.3684 161.209 50.5312L157.822 51.3344C155.887 51.7932 153.855 51.1789 152.498 49.7253L148.892 45.8619C148.564 45.5103 148.191 45.2029 147.784 44.9476L144.164 42.6808C142.242 41.4767 141.249 39.2215 141.658 36.9903L142.008 35.0862C142.216 33.9521 142.065 32.7814 141.576 31.7374L140.415 29.2614C139.521 27.3552 139.787 25.1071 141.099 23.4611L142.967 21.1196C143.319 20.6782 143.601 20.1857 143.804 19.659L145.586 15.0337C146.264 13.2746 147.791 11.9815 149.638 11.6022L154.089 10.6881C154.736 10.5553 155.354 10.3079 155.913 9.95759Z",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.312 44.228C170.579 44.228 177.281 37.5259 177.281 29.2586C177.281 20.9912 170.579 14.2891 162.312 14.2891C154.045 14.2891 147.343 20.9912 147.343 29.2586C147.343 37.5259 154.045 44.228 162.312 44.228Z",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.395 31.1391L158.541 35.0259L170.201 24.3156",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.539 109.77L138.687 120.299C138.11 123.582 140.635 126.59 143.968 126.59H184.896C188.229 126.59 190.754 123.582 190.177 120.299L188.325 109.77C186.655 100.278 186.655 90.5682 188.325 81.0767L190.177 70.5492C190.754 67.2666 188.229 64.2581 184.896 64.2581H143.968C140.635 64.2581 138.11 67.2666 138.687 70.5492L140.539 81.0765C142.208 90.5684 142.208 100.278 140.539 109.77Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.0e3896aba3bc3ddb8378989c2f786770.svg";
export { ForwardRef as ReactComponent };